import { InputControl, Text, cn } from '@growtherapy/sprout-ui';

import { QuestionTypeEnum } from '../types';
import { InputField } from './InputField';
import { QuestionProps } from './types';
import { getWordCount, validateValue } from './utils';

/**
 * Renders a form question with the appropriate input field based on the
 * question type. This component is uncontrolled and will maintain its own
 * internal state.
 *
 * Does not support complex intake form questions.
 */
export function Question(props: QuestionProps) {
  const { question, type, value } = props;
  const { title, placeholder: _placeholder } = question;
  const label = title;
  const isInlineRadio = type === QuestionTypeEnum.RADIO && question.layout === 'inline';

  const { inputControlError, shouldShowBasicRequiredError } = validateValue(props);
  const wordCount = type === QuestionTypeEnum.TEXT_AREA ? getWordCount(question, value) : undefined;

  return (
    <>
      <InputControl
        id={question.name}
        error={inputControlError}
        label={label}
        required={question.required}
        showNecessityIndicator={false}
        className={cn('mb-0', {
          '-mt-4': !label && question.visibleIf,
        })}
        errorClassName='text-base rebrand:text-status-error-surface'
        layoutClassName={cn('rebrand:[&_#input-word-count-preview-textarea]:text-text-inverse', {
          'flex items-center justify-between grow rebrand:flex-row': isInlineRadio,
        })}
        labelClassName={cn('text-base rebrand:text-text-inverse', { 'mb-0': isInlineRadio })}
        wordCount={wordCount}
      >
        <InputField {...props} />
      </InputControl>
      {shouldShowBasicRequiredError && (
        <Text className='mb-2 text-coral-700 rebrand:text-status-error-surface'>This field is required</Text>
      )}
    </>
  );
}
